import { defineMessages } from 'react-intl'

import { GTVehicleDocumentCategoryInput, GTVehicleRegistrationCategoryInput } from 'gql/types.generated'
import { TVehicleTemplateType } from 'gql/generated/graphql'

export const vehicleTypeMessages = defineMessages({
  [TVehicleTemplateType.Bus]: {
    id: 'dictionary.bus',
    defaultMessage: 'Bus'
  },
  [TVehicleTemplateType.Van]: {
    id: 'dictionary.van',
    defaultMessage: 'Van'
  },
  [TVehicleTemplateType.Sedan]: {
    id: 'dictionary.sedan',
    defaultMessage: 'Sedan'
  },
  [TVehicleTemplateType.Suv]: {
    id: 'dictionary.suv',
    defaultMessage: 'SUV'
  }
})

export const registrationCategoryMessages = defineMessages({
  [GTVehicleRegistrationCategoryInput.Federal]: {
    id: 'vehicles.form.registration.category.federal',
    defaultMessage: 'Federal'
  },
  [GTVehicleRegistrationCategoryInput.Local]: {
    id: 'vehicles.form.registration.category.local',
    defaultMessage: 'Local'
  },
  [GTVehicleRegistrationCategoryInput.DrivingPermit]: {
    id: 'vehicles.form.registration.category.drivingPermit',
    defaultMessage: 'Driving permit'
  }
})

export const documentsMessages = defineMessages({
  [GTVehicleDocumentCategoryInput.Photo]: {
    id: 'vehicles.form.documents.photo',
    defaultMessage: 'Vehicle photo'
  },
  [GTVehicleDocumentCategoryInput.Bills]: {
    id: 'vehicles.form.documents.bills',
    defaultMessage: 'Bills'
  },
  [GTVehicleDocumentCategoryInput.InternalInspection]: {
    id: 'vehicles.form.documents.internalInspection',
    defaultMessage: 'Internal inspection'
  },
  [GTVehicleDocumentCategoryInput.ExternalInspection]: {
    id: 'vehicles.form.documents.externalInspection',
    defaultMessage: 'External inspection'
  },
  [GTVehicleDocumentCategoryInput.TuningService]: {
    id: 'vehicles.form.documents.tuningService',
    defaultMessage: 'Tuning service document'
  },
  [GTVehicleDocumentCategoryInput.VerificationCertificate]: {
    id: 'vehicles.form.documents.lastVerificationCertificate',
    defaultMessage: 'Certificate of last verification'
  }
})
